<template>
  <div class="group-editor">
    <TitleBar
      :name="modelValue.name"
      :noun="noun"
      :entity-id="modelValue.id"
      id-prefix="upgrade"
      @rename="$emit('rename', $event)"
      @duplicate="$emit('duplicate')"
      @delete="$emit('delete')"
      @update:entity-id="$emit('update:modelValue', { ...modelValue, id: $event })"
    >
      <template #tabs>
        <StSegmentedControl v-model="tab" :options="tabs" size="sm" on-shell />
      </template>
    </TitleBar>

    <div class="group-editor__pane">
      <UpgradeGroupForm
        v-if="tab === 'editor'"
        hide-name
        hide-id
        :single-ability="singleAbility"
        :hide-rules="hideRules"
        :show-points="showPoints"
        points-position="top"
        :forced-ability-type="forcedAbilityType"
        :forced-keyword="forcedKeyword"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
      />
      <GroupPreview v-else :group="modelValue" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { IUpgrade } from '@scrolldex/shared';
import TitleBar from '../editor/TitleBar.vue';
import { StSegmentedControl, type SegmentOption } from '../ui/index.js';
import UpgradeGroupForm from './UpgradeGroupForm.vue';
import GroupPreview from './GroupPreview.vue';

withDefaults(
  defineProps<{
    modelValue: IUpgrade;
    noun?: string;
    singleAbility?: boolean;
    hideRules?: boolean;
    showPoints?: boolean;
    forcedAbilityType?: number;
    forcedKeyword?: string;
  }>(),
  { noun: 'Entry' },
);
defineEmits<{
  (e: 'update:modelValue', value: IUpgrade): void;
  (e: 'rename', next: string): void;
  (e: 'duplicate'): void;
  (e: 'delete'): void;
}>();

const tab = ref<string | number>('editor');
const tabs: SegmentOption[] = [
  { value: 'editor', label: 'Editor', icon: 'file-pen' },
  { value: 'preview', label: 'Preview', icon: 'eye' },
];
</script>

<style scoped>
.group-editor {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.group-editor__pane {
  padding: var(--st-space-3);
  overflow: auto;
}
</style>
